exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__radio___33BtC > span:last-child {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden; }\n\n.style__radio___33BtC {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding-right: 5px;\n  margin-right: 0; }\n  .style__radio___33BtC > span:last-child {\n    display: inline-flex;\n    align-items: center; }\n", ""]);

// exports
exports.locals = {
	"radio": "style__radio___33BtC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/ReversedRadio/style.scss
// module id = 2151
// module chunks = 6